import { useTranslation } from 'react-i18next';
import React from "react";
import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import { usePurchaseRoModel } from "../purchaseRoModel";
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel"
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum"
import useGlobalModel from "@/erp_subpackage/model/globalModel";

export function PageHeader() {
    const { t } = useTranslation();
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam, organTypeCode,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = usePurchaseRoModel();
    const { orgDs } = useGlobalModel(({ orgDs }) => [orgDs]);

    const searchFields = [
        {
            type: "Input",
            placeholder: t(`purchase.view.PageHeader.退货单号`),
            fieldName: "returnCode",
        },
        ...(organTypeCode === 3 ? [{
            type: "Select",
            placeholder: t(`purchase.view.PageHeader.所属机构`),
            fieldName: "shopId",
            options: orgDs
        }] : []),
        {
            type: "Select",
            placeholder: t(`purchase.view.PageHeader.单据状态`),
            fieldName: "status",
            mode: "multiple",
            options: getSelectedDictOne(DictCodeEnmu.PURCHASE_RETURN),
        },
        {
            type: "Input",
            placeholder: t(`purchase.view.PageHeader.供应商`),
            fieldName: "supplierName",
        },
        {
            type: "RangePicker",
            fieldName: "",
            placeholder: [t(`purchase.view.PageHeader.制单日期起始`), t(`purchase.view.PageHeader.制单日期结束`)],
            rangePickerFieldName: ["startTime", "endTime"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
    ]

    const searchMoreFields = [
        {
            type: "Select",
            placeholder: t(`purchase.view.PageHeader.结算类型`),
            fieldName: "payType",
            options: getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE),
        },
        {
            type: "Select",
            placeholder: t(`purchase.view.PageHeader.结算方式`),
            fieldName: "payMethodName",
            options: getSelectedDictOne(DictCodeEnmu.PAY_METHOD),
        },
        {
            type: "Select",
            placeholder: t(`purchase.view.PageHeader.支付状态`),
            fieldName: "payStatus",
            options: getSelectedDictOne(DictCodeEnmu.PAY_STATUS)
        },
        {
            type: "Input",
            placeholder: t(`purchase.view.PageHeader.制单人`),
            fieldName: "createUser"
        },
        {
            type: "RangePicker",
            fieldName: "",
            placeholder: [t(`purchase.view.PageHeader.结算开始`), t(`purchase.view.PageHeader.结算结束`)],
            rangePickerFieldName: ["settlementStartTime", "settlementEndTime"],
            format: "YYYY-MM-DD",
            span: 12,
            xxl: 6,
        },
    ]

    return (
        <YhPageHeader
            title={t(`purchase.view.PageHeader.采购退货`)}
            size="small"
            triggerSearch
            searchValues={searchParam}
            searchFields={searchFields}
            searchMoreFields={searchMoreFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { loadData({ pageNum: 1 }, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    );
}